import React from 'react'

import { Dialog, EmptyState, Text } from '@plurall/elo-beta'

interface IStudentLinkedResponsible {
  cells: Array<{
    id: number
    value: string
  }>
  id: string
  menu: []
}

interface IResponsibleLinkStudentSuccessModalProps {
  onClose: () => void
  onConfirm: () => void
  onCancel: () => void
  student: IStudentLinkedResponsible
}

const ResponsibleLinkStudentSuccessModal = ({
  onClose,
  onConfirm,
  onCancel,
  student,
}: IResponsibleLinkStudentSuccessModalProps) => {
  return (
    <Dialog
      onClose={onClose}
      title={'Vinculo do aluno'}
      dataTestId={'responsible-link-student-success-modal'}
      primaryButtonText={'Ver alunos vinculados'}
      onPrimaryClick={onConfirm}
      secondaryButtonText={'Vincular outro aluno'}
      onSecondaryClick={onCancel}
    >
      <EmptyState title={'Vinculado criado com sucesso'} variation={'waving'}>
        <Text
          size='t3'
          alignment='center'
          dimmed
          dataTestId={'responsible-link-student-success-text'}
        >
          Agora você pode visualizar os dados de {student?.cells[0]?.value} no Plurall.
        </Text>
      </EmptyState>
    </Dialog>
  )
}

export default ResponsibleLinkStudentSuccessModal
